// CustomPagination.js
import React from "react";
import { IoMdArrowBack, IoMdArrowForward } from "react-icons/io";

const CustomPagination = ({ currentPage, totalPages, onPageChange }) => {
  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      onPageChange(page);
    }
  };

  // Render a page button with conditional styling for the active page.
  const renderButton = (page) => (
    <button
      key={page}
      onClick={() => handlePageChange(page)}
      className={`px-3 py-1 border transition transform hover:text-[#E72848] ${
        page === currentPage ? "bg-[#FAFAFA] text-[#E72848]" : ""
      }`}
    >
      {page}
    </button>
  );

  const renderPages = () => {
    if (totalPages <= 5) {
      return Array.from({ length: totalPages }, (_, i) => renderButton(i + 1));
    }

    const pages = [];
    pages.push(renderButton(1));

    if (currentPage > 3) {
      pages.push(
        <span key="start-ellipsis" className="px-3 py-1">
          ...
        </span>
      );
    }

    if (currentPage > 2) {
      pages.push(renderButton(currentPage - 1));
    }

    if (currentPage !== 1 && currentPage !== totalPages) {
      pages.push(renderButton(currentPage));
    }

    if (currentPage < totalPages - 1) {
      pages.push(renderButton(currentPage + 1));
    }

    if (currentPage < totalPages - 2) {
      pages.push(
        <span key="end-ellipsis" className="px-3 py-1">
          ...
        </span>
      );
    }

    pages.push(renderButton(totalPages));
    return pages;
  };

  return (
    <nav className="flex items-center">
      <button
        onClick={() => handlePageChange(currentPage - 1)}
        disabled={currentPage === 1}
        className={`px-3 py-1 border rounded-l-lg flex items-center gap-2 transition transform disabled:opacity-50 ${currentPage !== 1 && 'hover:text-[#E72848]'}`}
      >
        <IoMdArrowBack /> Previous
      </button>
      {renderPages()}
      <button
        onClick={() => handlePageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        className={`px-3 py-1 border rounded-r-lg flex items-center gap-2 transition transform disabled:opacity-50 ${currentPage !== totalPages && 'hover:text-[#E72848]'}`}
      >
        Next <IoMdArrowForward />
      </button>
    </nav>
  );
};

export default CustomPagination;
